export default __webpack_public_path__ + "static/media/MLSA Beta.16ce8780.png";